import React from 'react'
import { styled } from '@mui/material/styles'
import login_bg from '@/asset/img/login_bg.webp'
import banner1 from '@/asset/img/bc_login_bg.webp'
import mobile_login from '@/asset/img/mobile_login.webp'
import { Side_Margin } from '@/constant'
import { LoginType } from '../index'
import { useMobileView } from '@/hooks'
export const LoginView = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'grid',
  placeItems: 'left',
  backgroundImage: `url(${banner1})`,
  backgroundSize: 'cover',
  backgroundPositionX: 'right',
  backgroundPositionY: 'center',
  [theme.breakpoints.down('sm')]: {
    backgroundImage: `url(${mobile_login})`,
    backgroundPositionY: 'top',
    backgroundPositionX: 'center',
    placeItems: 'center',
  },
}))

export const LoginBackgroundComponent = styled('img')(({ theme }) => ({
  position: 'absolute',
  objectFit: 'fill',
  zIndex: -1,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    top: 0,
    left: 0,
  },
}))

export const LoginBackground = () => {
  const isMobile = useMobileView()
  return <LoginBackgroundComponent src={isMobile ? mobile_login : login_bg} loading='lazy' />
}

export const LoginContent = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: `auto ${parseInt(Side_Margin) / 2}%`,
  // // width: "100%",
  // justifyContent: "flex-start",
  [theme.breakpoints.down('sm')]: {
    height: '100%',
    width: '100%',
  },
}))

export const LoginCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'type',
})<{ type: LoginType }>(({ theme, type }) => ({
  padding: '80px 48px',
  boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
  backgroundColor: '#fff',
  width: '50%',
  maxWidth: type === 'wechat_registry' ? '320px' : '640px',
  minWidth: type === 'wechat_registry' ? '420px' : '560px',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'transparent',
    width: '100%',
    minWidth: 'auto',
    maxWidth: 'auto',
    padding: '80px 20px',
    paddingBottom: '0px',
    justifyContent: 'flex-start',
    gap: '24px',
    alignItems: 'flex-start',
  },
}))

export const QRMobilView = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '80px',
  paddingTop: '80px',
  width: '100%',
  height: '100%',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.5) 0%, #FFFFFF 100%)',
  boxShadow: '0px -10px 40px 0px rgba(0,31,5,0.05)',
  borderRadius: '40px 40px 0px 0px',
  backdropFilter: 'blur(6px)',
}))

export const LoginHeader = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  // margin: "16px auto",
  gap: '16px',
}))

export const HeaderContent = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
}))

export const FlexRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const FlexColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
}))

export const Divider = styled('div')(() => ({
  height: '100%',
  width: '2px',
  margin: '0 30px',
  backgroundImage: 'linear-gradient(to bottom, #D9D9D900,#D9D9D95e,#D9D9D9,#D9D9D95e,#D9D9D900)',
}))
